import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export type UpdateCommissionParameterPropertyRequest = {
  id: number;
  propertyName: string;
  propertyValue: any;
}[];

export type UpdateCommissionParameterPropertyResponse = {
  isSuccess: boolean;
  message: string;
  data: any;
};

const updateCommissionParameterProperty = async (
  payload: UpdateCommissionParameterPropertyRequest
): Promise<UpdateCommissionParameterPropertyResponse> => {
  const { data } = await axiosInstance.post<UpdateCommissionParameterPropertyResponse>(
    "CommissionParameter/UpdateProperty",
    payload
  );
  return data;
};

export const useUpdateCommissionParameterProperty = () => {
  const queryClient = useQueryClient();

  return useMutation(updateCommissionParameterProperty, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.GetCommissionParameterList);
    },
  });
};
